export interface DomEventSubscription {
  dispose();
}

export class EventListenerRegistration {
  constructor(element: any) {
    this._element = element;
  }

  private _element: any;

  scroll(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('scroll', handler);
  }

  resize(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('resize', handler);
  }

  click(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('click', handler);
  }

  postMessage(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('message', handler);
  }

  devicechanged(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('ondevicechanged', handler);

  }

  popstate(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('popstate', handler);
  }

  hardwareBackButton(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('backbutton', handler);
  }

  protected _subscribe = (eventName: string, handler: EventListenerOrEventListenerObject): DomEventSubscription => {
    this._element.addEventListener(eventName, handler);
    return {
      dispose: () => this._element?.removeEventListener(eventName, handler)
    }
  }

}
